
import { Component, DestroyRef, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ERole } from 'src/app/core/enums/roles.enum';
import { RoleService } from 'src/app/core/services/roles.service';
import { UserService } from 'src/app/core/services/user.service';
import { MessageDialogComponent } from 'src/app/dialog/message-dialog/message-dialog.component';
import { IHello } from 'src/app/shared/models/hello.model';
import { IBasePerson } from 'src/app/shared/models/person.model';
import { environment } from 'src/environments/environment';
import { SlModalComponent, SlModalService, SlThemeSelectorComponent } from '@sl/sl-angular-library';
import { ReportModalComponent } from 'src/app/shared/components/reporting/report-modal.component';
import { LuIconComponent } from 'src/app/shared/components/lu-icon/lu-icon.component';
import { EApplicationStatus } from 'src/app/shared/enums/application-status.enum';
import { OfferService } from 'src/app/core/services/offer.service';
import { PendingOffersRefreshService } from 'src/app/core/services/pending-offers-refresh.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-admin-header',
    templateUrl: './admin-header.component.html',
    styleUrls: ['./admin-header.component.scss'],
    imports: [RouterModule, LuIconComponent, SlThemeSelectorComponent]
})
export class AdminHeaderComponent implements OnInit {

  @ViewChild(MessageDialogComponent)
  protected messageDialogComponent: MessageDialogComponent;	

  public errorModal: SlModalComponent;
  public reportModal: SlModalComponent;
  
  public user: IHello;
  public currentUser: IBasePerson | undefined;
  protected isDeveloper = false;  
  protected isAdmin = false;
  protected isSCS = false;
  protected hasConfigAuthority = false;
  protected isImpersonating = false;
  protected canGenerateReports = false;
  protected canAccessCandidatesAndHires = false;
  public title = '';
  public username: string | undefined = '';
  public pendingStatusCode: string = EApplicationStatus.AWAITING_SHEPHERDS_REVIEW.toString();
  public pendingInterviewStatusCode: string = EApplicationStatus.PENDING_INTERVIEW.toString();
  public pendingFinalDecisionStatusCode: string = EApplicationStatus.PENDING_FINAL_DECISION.toString();
  public pendingOfferStatusCode: string = EApplicationStatus.PENDING_OFFER.toString();

  protected logoutUrl =  `${environment.apiUrl}/logout`

  public pendingOffersCount: number = 0;

  constructor(
      private roleService: RoleService,
      private userService: UserService,
      private slModalService: SlModalService,
      private offerService: OfferService,
      private pendingOffersRefeshService: PendingOffersRefreshService,
      private readonly destroyRef: DestroyRef
    ){
      this.pendingOffersRefeshService.refresh$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.loadPendingOffers();
        });
    }

  ngOnInit(): void {
    this.isAdmin = this.roleService.hasRole(ERole.SHEPHERDS_ADMIN);
    this.isSCS = this.roleService.hasRole(ERole.STAFF_SCS);
    this.canGenerateReports = this.roleService.hasAnyRole([ERole.STAFF_RSCGL, ERole.STAFF_AS, ERole.STAFF_CS]) && !this.isSCS;
    this.canAccessCandidatesAndHires = !this.isSCS;
    this.hasConfigAuthority = this.roleService.hasRole(ERole.SHEPHERDS_CONFIG);
    this.title = this.isAdmin ? 'ADMIN' : '';
    
    this.isDeveloper = this.roleService.hasAnyRole([ERole.SHEPHERDS_SWITCH_USER]);
    this.userService.helloUser().subscribe(user => {
      if (user.currentUser != null) {
        this.user = user; 
        this.currentUser = user.currentUser
        this.username = user.currentUser.printName;
        this.isImpersonating = user.impersonatingUser != null;
      }
    });

    this.loadPendingOffers();
  }

  public loadPendingOffers(): void {
    this.offerService.getAllActiveOffersCount().subscribe((pendingOffersCount) => {
      this.pendingOffersCount = pendingOffersCount;
    });
  }

  public openErrorModal(errorMessage: string): void {
    this.errorModal = this.slModalService.createModal({
      title: "Request Failed",
      message: errorMessage,
      class: 'error-modal',
    });
  }

  protected openReportModal(): void {
    this.reportModal = this.slModalService.createModal({
      title: `Generate CSV Report`,
      bodyComponent: ReportModalComponent
    })
  }

}
